import { useEffect, useRef } from "react";

/**
 * Runs `cb` at most once per frame while the page scrolls (and on resize).
 * Scroll handlers that write to the DOM directly — rather than to React state —
 * keep the 60fps path free of reconciliation entirely.
 */
export default function useRafScroll(cb) {
  const cbRef = useRef(cb);
  cbRef.current = cb;

  useEffect(() => {
    let frame = 0;
    let alive = true;

    const tick = () => {
      frame = 0;
      if (alive) cbRef.current();
    };

    const request = () => {
      if (!frame) frame = requestAnimationFrame(tick);
    };

    request();
    window.addEventListener("scroll", request, { passive: true });
    window.addEventListener("resize", request);

    return () => {
      alive = false;
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener("scroll", request);
      window.removeEventListener("resize", request);
    };
  }, []);
}
